import serviceBase from '../../../../Services/serviceBase'
// eslint-disable-next-line no-unused-vars
import _ from 'lodash'

class ResidentialPlansActions {
  getResidentialPlans = async (legacyId, id, filterCriteria) => {
    let url = `${window._env_.COMMUNITY_API_URL || 'https://communityapi-qa.iartest.com/api/v1'
      }/residential-plan/by-department/${legacyId}/${id}?filter=${filterCriteria}`
    return serviceBase.get(url).then(
      (response) => {
        return response.data
      },
      (err) => { }
    )
  }

  getAutomaticApproveResidentialPlans = async (fireDepartmentId, iarMember) => {
    const scapeIarMember = _.deburr(iarMember)
    let url = `${window._env_.COMMUNITY_API_URL
      }/department-settings/department-settings-by-department-id/${fireDepartmentId}`
    return serviceBase.get(url, {
      crossDomain: true,
      'Content-Type': 'application/json',
      Authorization: ``,
      sourcesystem: "1",
      fullusername: scapeIarMember
    }).then(
      (response) => {
        return response.data
      },
      (err) => { }
    )
  }

  approveResidentialPlans = async (ids, iarMember) => {
    const scapeIarMember = _.deburr(iarMember)
    let url = `${window._env_.COMMUNITY_API_URL
      }/residential-plan/approve`
    return serviceBase.post(url, { toApprove: ids }, {
      crossDomain: true,
      'Content-Type': 'application/json',
      Authorization: ``,
      sourcesystem: "1",
      fullusername: scapeIarMember
    }).then(
      (response) => {
        if (response.status === 200) {
          return true
        }
        else {
          return false
        }
      },
      (err) => { }
    )
  }

  automaticApproveDepartmentSettings = async (fireDepartmentId, identifier, iarMember, residentialPlanAutomaticApprove) => {
    const scapeIarMember = _.deburr(iarMember)
    let url = `${window._env_.COMMUNITY_API_URL
      }/department-settings`
    return serviceBase.post(url, {
      fireDepartmentId: fireDepartmentId,
      identifier: identifier,
      automaticResidentialPlansApprove: residentialPlanAutomaticApprove
    }, {
      crossDomain: true,
      'Content-Type': 'application/json',
      Authorization: ``,
      sourcesystem: "1",
      fullusername: scapeIarMember
    }).then(
      (response) => {
        if (response.status === 200) {
          return true
        }
        else {
          return false
        }
      },
      (err) => { }
    )
  }

  automaticApproveResidentialPlans = async (fireDepartmentId, identifier, iarMember, residentialPlanAutomaticApprove) => {
    const scapeIarMember = _.deburr(iarMember)
    let url = `${window._env_.COMMUNITY_API_URL
      }/residential-plan/approve-by-department`
    return serviceBase.post(url, {
      fireDepartmentId: fireDepartmentId,
      identifier: identifier,
      automaticResidentialPlansApprove: residentialPlanAutomaticApprove
    }, {
      crossDomain: true,
      'Content-Type': 'application/json',
      Authorization: ``,
      sourcesystem: "1",
      fullusername: scapeIarMember
    }).then(
      (response) => {
        if (response.data === true) {
          return true
        }
        else {
          return false
        }
      },
      (err) => { }
    )
  }
}

export default new ResidentialPlansActions()
